<template>
  <div id="data-list-list-view" class="data-list-container">

    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>
    <vx-card collapse="false" ref="filterCard" title="Filter" class="user-list-filters mb-8" collapse-action
             refresh-content-action @refresh="resetFilters">
      <h5 class="mt-5 mb-2">Filter by date</h5>
      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <flat-pickr :config="configdateTimePicker" v-model="startDate"
                      placeholder="From"
                      class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2">
          <flat-pickr :config="configdateTimePicker" v-model="endDate"
                      placeholder="To"
                      class="w-full"/>
        </div>
        <div class="vx-col mt-2">
          <vs-button @click="filterByDate" class="mr-6 vs-align-right">Filter</vs-button>
        </div>
      </div>
    </vx-card>

    <detail :isSidebarActive="detailSidebar" @closeSidebar="toggleDetail"
            :data="sidebarData"/>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="orders">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ orders.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : orders.length }} de {{
                queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="number">Number</vs-th>
        <vs-th sort-key="number">Store Identifier</vs-th>
        <vs-th sort-key="date">Order date</vs-th>
        <vs-th sort-key="date">Order time</vs-th>
        <vs-th sort-key="deliveryDate">Delivery date</vs-th>
        <vs-th sort-key="total">Total</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr class='clickable-row' :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.id.substr(0, 6).toUpperCase() }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.client.displayName }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.createdAt | date(true) }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.createdAt | time(true) }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.deliveryDate | date(true) }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">$ {{ parseFloat(tr.total) | round }}</p>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Detail from './Detail'

const firebase = require("firebase")
// Required for side-effects
require("firebase/firestore")
let db = firebase.firestore()
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    Detail,
    flatPickr
  },
  data() {
    return {
      selected: null,
      itemsPerPage: 10,
      isMounted: false,
      ordersPre: [],
      products: [],
      productsDetail: [],
      initProgress: false,
      client: {},

      //Filters
      filter: false,

      statesOptions: [
        {label: 'All', value: -1},
        {label: 'On hold', value: 'onHold'},
        {label: 'Accepted', value: 'success'},
        {label: 'Rejected', value: 'rejected'},
        {label: 'Delivered', value: 'delivered'}
      ],
      deliveriesOptions: [
        {label: 'All', value: -1}
      ],

      stateFilter: {
        label: 'Todos',
        value: -1
      },

      startDate: '',
      endDate: '',

      //

      // Date
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },

      // Data Sidebar
      newSidebar: false,
      detailSidebar: false,
      sidebarData: {},
      // Export
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      activePrompt: false,
      activePromptOrders: false
    }
  },
  async created() {
    try {
      this.initProgress = true
      await this.loadOrders()
      await this.loadProducts()
      this.initProgress = false
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'There was a mistake.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    orders: {
      get() {
        return this.$store.state.orders.orders
      }
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.orders.length
    }
  },
  watch: {
    async stateFilter(val) {
      if (val.value !== -1) {
        this.initProgress = true
        this.ordersPre = []
        await this.$store.dispatch('orders/fetchOrders', {orders: this.ordersPre})

        db.collection("orders").where('state', '==', this.stateFilter.value)
            .orderBy('createdAt', 'desc').limit(100).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let order = {
              id: doc.id,
              ...doc.data(),
              createdAt: doc.data().createdAt.toDate(),
              deliveryDate: doc.data().deliveryDate.toDate()
            }
            if (doc.data().observation) {
              order.observation = doc.data().observation
            }
            this.ordersPre.push(order)
          })
          this.initProgress = false
          this.$store.dispatch('orders/fetchOrders', {orders: this.ordersPre})
        }).catch((e) => {
          console.log(e)
          this.initProgress = false
          this.$vs.notify({
            color: 'warning',
            title: '¡Oh no!',
            text: 'There was a mistake.'
          })
        })
      }
    },
    selected(val) {
      this.sidebarData = {
        ...val
      }
      this.toggleDetail(true)
    }
  },
  methods: {
    toggleDetail(val = false) {
      this.detailSidebar = val
    },
    getStateText(value) {
      if (value === 'onHold') return "On hold"
      if (value === 'success') return "Accepted "
      if (value === 'rejected') return "Rejected "
      if (value === 'delivered') return "Delivered"
    },
    loadOrders() {
      this.ordersPre = []
      this.$store.dispatch('orders/fetchOrders', {orders: this.ordersPre})

      return new Promise((resolve, rejected) => {
        //Get orders
        db.collection("orders").orderBy('createdAt', 'desc').limit(100).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let order = {
              id: doc.id,
              ...doc.data(),
              createdAt: doc.data().createdAt.toDate(),
              deliveryDate: doc.data().deliveryDate.toDate()
            }
            if (doc.data().observation) {
              order.observation = doc.data().observation
            }
            this.ordersPre.push(order)
          })
          resolve('ok')
          this.$store.dispatch('orders/fetchOrders', {orders: this.ordersPre})
        }).catch((error) => {
          rejected(error)
        })
      })
    },
    loadProducts() {
      this.products = []
      return new Promise((resolve, rejected) => {
        db.collection("products").orderBy('createdAt', 'desc').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let productDetail = {
              id: doc.id,
              name: doc.data().name,
              brand: doc.data().brand,
              price: doc.data().price,
              size: doc.data().size,
              labelName: doc.data().name + " / " + doc.data().brand.name + " / " + doc.data().size,
              features: doc.data().features || null,
              quantity: 1
            }
            this.productsDetail.push(productDetail)
          })
          resolve('ok')
        }).catch((error) => {
          rejected(error)
        })
      })
    },
    async resetFilters() {
      this.initProgress = true
      await this.loadOrders()
      this.initProgress = false

      this.stateFilter = {
        label: 'All',
        value: -1
      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    async filterByDate() {
      try {
        this.initProgress = true
        this.ordersPre = []
        const starTimes = firebase.firestore.Timestamp.fromDate(new Date(this.startDate))
        const endTimes = firebase.firestore.Timestamp.fromDate(new Date(this.endDate))
        let querySnap = ''
        if (this.stateFilter.value === -1) {
          querySnap = await db.collection('orders')
              .where('createdAt', '>=', starTimes)
              .where('createdAt', '<=', endTimes).get()
        } else {
          querySnap = await db.collection('orders')
              .where('createdAt', '>=', starTimes)
              .where('createdAt', '<=', endTimes)
              .where('state', '==', this.stateFilter.value).get()
        }

        querySnap.forEach((doc) => {
          let order = {
            id: doc.id,
            ...doc.data(),
            createdAt: doc.data().createdAt.toDate(),
            deliveryDate: doc.data().deliveryDate.toDate()
          }
          if (order.confirm !== false) {
            this.ordersPre.push(order)
          }
        })
        this.initProgress = false
        this.$store.dispatch('orders/fetchOrders', {orders: this.ordersPre})
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'There was a mistake.'
        })
      } finally {
        this.initProgress = false
      }
    },
    orderDetail(tr) {
      this.sidebarData = tr
      this.toggleDetail(true)
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
